export default __webpack_public_path__ + "static/media/dateRange.7d9f2c14.svg";